var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analyse" },
    [
      _c(
        "v-card",
        { staticClass: "mb-4 csat-shell-card" },
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("AI Trust Score & CSAT")
          ]),
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "", "grid-list-md": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "csat-shell-left",
                      attrs: { xs12: "", sm4: "" }
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "csat-panel-card" },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "pt-0" },
                            [
                              _c("csat-trust-score", {
                                attrs: {
                                  embedded: "",
                                  view: "left",
                                  "history-active": _vm.showCsatHistory,
                                  visitors: _vm.visiteurs,
                                  params: _vm.params,
                                  numChatsTotal: String(_vm.chatsOK)
                                },
                                on: {
                                  "toggle-history": function($event) {
                                    _vm.showCsatHistory = !_vm.showCsatHistory
                                  },
                                  "analysis-start": _vm.onCsatAnalysisStart,
                                  "analysis-result": _vm.onCsatAnalysisResult,
                                  "analysis-error": _vm.onCsatAnalysisError
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm8: "" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "csat-panel-card pa-3" },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "csat-right-placeholder" },
                            [
                              _vm.showCsatHistory
                                ? _c(
                                    "div",
                                    [
                                      _c("csat-trust-score", {
                                        attrs: {
                                          embedded: "",
                                          view: "history",
                                          visitors: _vm.visiteurs,
                                          params: _vm.params,
                                          numChatsTotal: String(_vm.chatsOK)
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "csat-right-results" },
                                    [
                                      _vm.csatRightLoading
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "csat-right-loading"
                                            },
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  indeterminate: "",
                                                  color: "primary",
                                                  size: 48,
                                                  width: 4
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mt-3 body-1 grey--text text--darken-1"
                                                },
                                                [
                                                  _vm._v(
                                                    "Calcul du score CSAT en cours..."
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm.csatRightError
                                        ? _c(
                                            "v-alert",
                                            {
                                              attrs: {
                                                type: "error",
                                                value: "true"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(_vm.csatRightError) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm.csatRightSummary
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  staticClass:
                                                    "csat-right-top-row",
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        md4: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          staticClass:
                                                            "pa-2 csat-card-stretch csat-score-card"
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-title",
                                                            {
                                                              attrs: {
                                                                "primary-title":
                                                                  ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "subheading font-weight-bold grey--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "AI CSAT Score"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-xs-center"
                                                            },
                                                            [
                                                              _c(
                                                                "v-progress-circular",
                                                                {
                                                                  attrs: {
                                                                    rotate: 270,
                                                                    size: 120,
                                                                    width: 20,
                                                                    value:
                                                                      _vm.csatRightScoreValue,
                                                                    color:
                                                                      _vm.csatRightGaugeColor
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "display-1 font-weight-bold",
                                                                      style: {
                                                                        color:
                                                                          _vm.csatRightGaugeColor
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            _vm.csatRightSummary
                                                                              ? _vm
                                                                                  .csatRightSummary
                                                                                  .global_score
                                                                              : "-"
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "grey--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "sur 100"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.csatRightPreviousSummary
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mt-3"
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "caption grey--text"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Periode precedente: "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .csatRightPreviousSummary
                                                                          .global_score
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.csatRightPreviousSummary
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mt-1 font-weight-bold",
                                                                  class:
                                                                    _vm.csatRightDeltaClass
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.csatRightFormattedDelta
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                flat:
                                                                  _vm.csatRightOpenSection !==
                                                                  "recommendations",
                                                                color:
                                                                  _vm.csatRightOpenSection ===
                                                                  "recommendations"
                                                                    ? "accent"
                                                                    : ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.csatRightOpenSection =
                                                                    _vm.csatRightOpenSection ===
                                                                    "recommendations"
                                                                      ? "score"
                                                                      : "recommendations"
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Recommandations "
                                                              ),
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "ml-2",
                                                                  attrs: {
                                                                    dark: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "fact_check"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: false,
                                                                  expression:
                                                                    "false"
                                                                }
                                                              ],
                                                              attrs: {
                                                                small: "",
                                                                flat: _vm.csatR,
                                                                color:
                                                                  _vm.csatRightOpenSection ===
                                                                  "output"
                                                                    ? "primary"
                                                                    : ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.csatRightOpenSection =
                                                                    _vm.csatRightOpenSection ===
                                                                    "output"
                                                                      ? "score"
                                                                      : "output"
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Output\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        md8: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.csatRightOpenSection ===
                                                                "recommendations",
                                                              expression:
                                                                "csatRightOpenSection === 'recommendations'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "pa-2 csat-card-stretch text-xs-left"
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-title",
                                                            {
                                                              attrs: {
                                                                "primary-title":
                                                                  ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "subheading font-weight-bold grey--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Recommandations"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.csatRightSummary &&
                                                              _vm
                                                                .csatRightSummary
                                                                .recommendations &&
                                                              _vm
                                                                .csatRightSummary
                                                                .recommendations
                                                                .length
                                                                ? _c(
                                                                    "ul",
                                                                    {
                                                                      staticClass:
                                                                        "csat-list"
                                                                    },
                                                                    _vm._l(
                                                                      _vm
                                                                        .csatRightSummary
                                                                        .recommendations,
                                                                      function(
                                                                        item,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "li",
                                                                          {
                                                                            key:
                                                                              "right-rec-" +
                                                                              index
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "caption grey--text"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Aucune recommandation disponible."
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "tf-gap-wrap mt-3"
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                        outline:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.goToOpenAIConfigPromptSystem
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              Ameliorer le prompt du chatbot "
                                                                      ),
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "ml-2",
                                                                          attrs: {
                                                                            dark:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "launch"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                        outline:
                                                                          ""
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.goToOpenAIConfigPromptCsat
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              Ameliorer le prompt CSAT "
                                                                      ),
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "ml-2",
                                                                          attrs: {
                                                                            dark:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "launch"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-card",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.csatRightOpenSection ===
                                                                "score",
                                                              expression:
                                                                "csatRightOpenSection === 'score'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "pa-2 csat-card-stretch text-xs-left"
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-title",
                                                            {
                                                              attrs: {
                                                                "primary-title":
                                                                  ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "subheading font-weight-bold grey--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Contexte"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mt-3"
                                                                },
                                                                [
                                                                  _c("div", [
                                                                    _vm._v(
                                                                      "\n                              Conversations scorees : "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .csatRightSummary
                                                                              .conversation_count
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("br"),
                                                                    _vm._v(
                                                                      "\n                              Erreurs non bloquantes : "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .csatRightSummary
                                                                              .error_count
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("br"),
                                                                  _vm._v(" "),
                                                                  _vm
                                                                    .csatRightSummary
                                                                    .insights &&
                                                                  _vm
                                                                    .csatRightSummary
                                                                    .insights
                                                                    .length
                                                                    ? _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                "Insights"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "ul",
                                                                            {
                                                                              staticClass:
                                                                                "csat-list"
                                                                            },
                                                                            _vm._l(
                                                                              _vm
                                                                                .csatRightSummary
                                                                                .insights,
                                                                              function(
                                                                                item,
                                                                                index
                                                                              ) {
                                                                                return _c(
                                                                                  "li",
                                                                                  {
                                                                                    key:
                                                                                      "right-ins-" +
                                                                                      index
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.csatRightOpenSection ===
                                                            "output",
                                                          expression:
                                                            "csatRightOpenSection === 'output'"
                                                        }
                                                      ],
                                                      staticClass: "mt-3",
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          staticClass:
                                                            "pa-4 csat-soft-card text-xs-left"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "subheading mb-2"
                                                            },
                                                            [_vm._v("Output")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("v-textarea", {
                                                            attrs: {
                                                              value:
                                                                _vm.csatRightOutputText,
                                                              "auto-grow": "",
                                                              rows: "10",
                                                              outline: "",
                                                              readonly: ""
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "caption grey--text"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Lancez une analyse pour afficher le score, les recommandations et l'output ici.\n                "
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("Analyse I.A. custom")
          ]),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "v-card-text",
                { staticClass: "text-xs-center pt-3" },
                [
                  _c("v-progress-circular", {
                    staticClass: "primary--text",
                    attrs: { indeterminate: "" }
                  })
                ],
                1
              )
            : _c(
                "v-container",
                { attrs: { fluid: "", "grid-list-md": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm4: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "pa-3" },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.questions,
                                  "item-text": "valeur",
                                  "item-value": "cle",
                                  label: "Analyses",
                                  multiple: "",
                                  chips: "",
                                  "return-object": "",
                                  hint: "paramétrez votre analyse",
                                  "persistent-hint": ""
                                },
                                model: {
                                  value: _vm.suggestionsProxy,
                                  callback: function($$v) {
                                    _vm.suggestionsProxy = $$v
                                  },
                                  expression: "suggestionsProxy"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-textarea", {
                                attrs: {
                                  label: "Votre demande personalisée",
                                  clearable: "",
                                  "auto-grow": "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.analyseMessage,
                                  callback: function($$v) {
                                    _vm.analyseMessage = $$v
                                  },
                                  expression: "analyseMessage"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    loading: _vm.loadingData,
                                    disabled: _vm.loadingData,
                                    color: "primary",
                                    block: ""
                                  },
                                  on: { click: _vm.sendMAnalyseChat }
                                },
                                [
                                  _vm._v(
                                    "\n              Analyser\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm8: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "pa-3", attrs: { height: "100%" } },
                            [
                              _c("v-card-text", [
                                _c("div", {
                                  staticClass: "markdown-output text-xs-left",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.analyseResponse)
                                  }
                                })
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48f2d9a3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f2d9a3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/analyse.vue
// module id = null
// module chunks = 